import React from "react";
import Paragraphs from "../../src/components/Article/Paragraphs/index.js";
import File from "../components/File/index.js";
import Alert from "../components/Alert/index.js";
import SmallHero from "../components/SmallHero/index.js";
import Tags from "../components/Tags/index.js";
import Image from "../components/Article/Image/index.js";
import ArticleWrapper from "../components/Article/Wrapper/index.js";
import ArticleTitle from "../components/Article/ArticleTitle/index.js";
import Features from "../components/Features/index.js";
import VideoPlayer from "../components/VideoPlayer/index.js";
import SectionHeader from "../components/Article/SectionHeader/index.js";
import ArticleSubtitle from "../components/Article/ArticleSubtitle/index.js";
import BigHero from "../components/BigHero/index.js";
import CardSlider from "../components/CardSlider/index.js";
import CardHero from "../components/CardHero/index.js";
import { Needs } from "../components/Needs/index.js";
import Breadcrumbs from "../components/Breadcrumbs/index.js";
import Presentation from "../components/Presentation/index.js";
import Tabs from "../components/Tabs/index.js";
import Awards from "../components/Awards/index.js";
import Buttons from "../components/Buttons/index.js";
import ReferencedTabs from "../components/Referenced tabs/index.js";
import clsx from "clsx";
import PropTypes from "prop-types";
import Table from "../components/Article/Table/index.js";
import QuickFAQ from "../components/QuickFAQ/index.js";
import SelectedBlock from "../components/SelectedBlock/index.js";
import QuickNews from "../components/QuickNews/index.js";
import Exchange from "../components/Exchange/index.js";
import { AppsBanner } from "../components/AppsBanner";
import { CollapsableList } from "../components/CollapsableList";
import { UsefulLinks } from "../components/UsefulLinks";
import { Letter } from "../components/Letter";
import { CategoryBlock } from "../components/CategoryBlock/index.js";
import ImageGallery from "../components/ImageGallery/index.js";
import JobVacancies from "../components/JobVacancies/index.js";
import CheckList from "../components/CheckList/index.js";
import BusinessNeeds from "../components/BusinessNeeds/index.js";
import ApplicationsDownloadBanner from "../components/ApplicationsDownloadBanner/index.js";
import { DigitalPlatforms } from "../components/DigitalPlatforms/index.js";
import { Partners } from "../components/Partners/index.js";
import BubbleBlock from "../components/BubbleBlock/index.js";
import ArticleTable from "../components/ArticleTable/index.js";

export function Patterns({ data, section, wrapper }) {
  let sectionClasses = "site-block";
  let wrapperClasses = "wrapper";

  if (section === "aside") {
    sectionClasses = "site-block site-block--pt-10 site-block--pb-10";
  }

  if (wrapper === "article") {
    wrapperClasses = "wrapper wrapper--950";
  }

  return data.map((pattern) => {
    if (
      pattern.__typename === "API_ComponentArticlePatternBodyMainSlider" ||
      pattern.strapi_component === "article-pattern-body.main-slider"
    ) {
      return <Presentation data={pattern.slides} />;
    } else if (pattern.__typename === "API_ComponentArticlePatternBodyNeeds") {
      return (
        <Needs
          data={Object.keys(pattern)
            .filter((key) => typeof pattern[key] === "object")
            .map((key) => ({ ...pattern[key], _type: key }))}
        />
      );
    } else if (
      pattern.__typename === "API_ComponentArticlePatternBodyParagraph"
    ) {
      return <Paragraphs data={pattern.content} />;
    } else if (pattern.__typename === "API_ComponentArticlePatternBodyTable") {
      return <Table data={pattern} />;
    } else if (
      pattern.__typename === "API_ComponentArticlePatternBodyAttachedFile"
    ) {
      return <File data={pattern} />;
    } else if (pattern.__typename === "API_ComponentArticlePatternBodyAlert") {
      return <Alert data={pattern} />;
    } else if (
      pattern.__typename === "API_ComponentArticlePatternBodySimpleBanner"
    ) {
      return <SmallHero data={pattern} />;
    } else if (pattern.__typename === "API_ComponentArticlePatternBodyTags") {
      return <Tags data={pattern.Tag} />;
    } else if (
      pattern.__typename === "API_ComponentArticlePatternBodySingleImage"
    ) {
      return <Image data={pattern} />;
    } else if (
      pattern.__typename === "API_ComponentArticlePatternBodyFeatureIcons"
    ) {
      return (
        <Features
          data={pattern.Icon}
          wrapperProps={{ horizontal: true, four: true }}
        />
      );
    } else if (pattern.__typename === "API_ComponentArticlePatternBodyVideo") {
      return <VideoPlayer data={pattern} />;
    } else if (
      pattern.__typename === "API_ComponentArticlePatternBodySubheader"
    ) {
      return <SectionHeader data={pattern} />;
    } else if (pattern.__typename === "API_ComponentArticlePatternBodyHeader") {
      return <ArticleSubtitle data={pattern} />;
    } else if (
      pattern.__typename === "API_ComponentArticlePatternBodyBannerWithText"
    ) {
      return <BigHero data={pattern} />;
    } else if (
      pattern.__typename === "API_ComponentArticlePatternBodyCardsSlider"
    ) {
      return <CardSlider data={pattern.cards} />;
    } else if (
      pattern.__typename === "API_ComponentArticlePatternBodyCardBanner"
    ) {
      return <CardHero data={pattern} />;
    } else if (pattern.__typename === "API_ComponentArticlePatternBodyTabs") {
      return <Tabs data={pattern.tabs} />;
    } else if (
      pattern.__typename === "API_ComponentArticlePatternBodyReferencedTabs"
    ) {
      return <ReferencedTabs data={pattern.tabs} />;
    } else if (
      pattern.__typename === "API_ComponentArticlePatternBodyExternalLinks"
    ) {
      return <Buttons data={pattern} />;
    } else if (pattern.__typename === "API_ComponentArticlePatternBodyAwards") {
      return <Awards />;
    } else if (pattern.__typename === "API_ComponentArticlePatternBodyFaq") {
      return <QuickFAQ data={pattern} />;
    } else if (pattern.__typename === "API_ComponentArticlePatternBodyCards") {
      return <SelectedBlock data={pattern} />;
    } else if (
      pattern.__typename === "API_ComponentArticlePatternBodyBlog" ||
      pattern.strapi_component === "article-pattern-body.blog"
    ) {
      return <QuickNews />;
    } else if (
      pattern.__typename === "API_ComponentArticlePatternBodyExchange"
    ) {
      return (
        <div className="currency mt-3">
          <Exchange />
          <main className="main-content"></main>
          <main className="main-content"></main>
          <main className="main-content"></main>
          <main className="main-content"></main>
        </div>
      );
    } else if (
      pattern.__typename === "API_ComponentArticlePatternBodyCollapsible"
    ) {
      return <CollapsableList data={pattern.items || []} />;
    } else if (
      pattern.__typename === "API_ComponentArticlePatternBodyUsefulLinks"
    ) {
      return <UsefulLinks data={pattern} />;
    } else if (
      pattern.__typename ===
      "API_ComponentArticlePatternBodyMobileApplicationBanner"
    ) {
      return <AppsBanner />;
    } else if (pattern.__typename === "API_ComponentArticlePatternBodyLetter") {
      return <Letter data={pattern.letter || []} />;
    } else if (
      pattern.__typename === "API_ComponentArticlePatternBodyCategoryBlock"
    ) {
      return <CategoryBlock data={pattern} />;
    } else if (
      pattern.__typename === "API_ComponentArticlePatternBodyImageGallery"
    ) {
      return <ImageGallery data={pattern} />;
    } else if (
      pattern.__typename === "API_ComponentArticlePatternBodyJobVacancies"
    ) {
      return <JobVacancies data={pattern} />;
    } else if (
      pattern.__typename === "API_ComponentArticlePatternBodyCheckList"
    ) {
      return <CheckList data={pattern} />;
    } else if (
      pattern.__typename === "API_ComponentArticlePatternBodyBusinessNeeds"
    ) {
      return <BusinessNeeds data={pattern} />;
    } else if (
      pattern.__typename === "API_ComponentArticlePatternBodyDigitalPlatforms"
    ) {
      return <DigitalPlatforms />;
    } else if (
      pattern.__typename === "API_ComponentArticlePatternBodyPartners"
    ) {
      return <Partners />;
    } else if (
      pattern.__typename ===
      "API_ComponentArticlePatternBodyApplicationsDownloadBanner"
    ) {
      return <ApplicationsDownloadBanner data={pattern} />;
    } else if (
      pattern.__typename === "API_ComponentArticlePatternBodyBubbleBlock"
    ) {
      return <BubbleBlock data={pattern} />;
    } else if (
      pattern.__typename === "API_ComponentArticlePatternBodyArticleTable"
    ) {
      return <ArticleTable data={pattern} />;
    }
  });
}

Patterns.propTypes = {
  section: PropTypes.oneOf(["aside", "default"]),
  wrapper: PropTypes.oneOf(["article", "default"]),
};

export default Patterns;
